
import { STATUS_TYPE } from '../../../enum';
import { UserInfo } from '../../userInfo/api/interface';

export interface KnoCardLinkSessionRequestResponse {
  status: string;
  message?: string;
  data: {
    current_page?: number;
    data: KnoCardLinkSessionRequestItem[];
    first_page_url?: string;
    from?: number;
    last_page?: number;
    last_page_url?: string;
    next_page_url?: string;
    path?: string;
    per_page?: number;
    prev_page_url?: string;
    to?: number;
    total?: number;
  };
}

export interface KnoCardLinkSessionRequestItem {
  id?: number;
  user_id?: number;
  to_user_id?: number;
  new_prospects?: number;
  referrals?: number;
  media_share?: number;
  rf_lp?: number;
  personal_shares?: number;
  social_posts?: number;
  status?: string;
  created_at?: string;
  updated_at?: string;
  next_coaching: Date;
  next_followup: Date;
  to_user: UserInfo;
  // user?: UserInfo;
}

export interface PatchKnoCardLinkSessionRequest {
  id: number;
  next_coaching: Date;
  next_followup: Date;
}

export interface PatchKnoCardLinkSessionResponse {
  status: string;
  message?: string;
  data: KnoCardLinkSessionRequestItem
}

interface InitialState {
  data: KnoCardLinkSessionRequestItem[];
  page: number;
  total: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  page: 0,
  total: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
